import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../services/userService/user.service'
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contactdetail',
  templateUrl: './contactdetail.component.html',
  styleUrls: ['./contactdetail.component.css']
})

export class ContactdetailComponent implements OnInit {
  registerForm: any;
  id: any;
  formdata: any;
  Whatsapp: any;
  IsFactoryVisit: any;
  userRId: any;
  permission: any;

  constructor(
    private formBuilder: FormBuilder,
    private UserService: UserService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    let decid = this.route.snapshot.params['id'];
    decid = decid.toString().replace('Ar1t', '=').replace('FGH', '/').replace('THD', '+');
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem('Permission'));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Contact_View != 1 && this.userRId != 1) {
      this.toastr.error('You do not have permission');
      this.router.navigate(['/profile']);
    }

    this.registerForm = this.formBuilder.group({
      ContactId: this.id,
      ContactName: ['', Validators.required],
      Mobile: [''],
      Email: [''],
      Country: ['', Validators.required],
      State: ['', Validators.required],
      City: ['', Validators.required],
      Designation: ['', Validators.required],
      Company: ['', Validators.required],
      ContactOwner: ['', Validators.required],
      Gender: ['', Validators.required],
      Nationality: ['', Validators.required],
      Language: [''],
      Religion: [''],
      ProReservation: [''],
      Landline: [''],
      WhatsappNumber: [''],
      DateOfBirth: [''],
      Address1: [''],
      Address2: [''],
      IsVVIP: [''],
      IsFactoryVisit: [''],
      FactoryVisitComments: [''],
      Comments: [''],
    })

    let data = {
      "ContactId": this.id
    }
    this.UserService.GetEditContactDetail(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.formdata = res['Data'];
        this.Whatsapp = this.formdata.WhatsappNumber;
        if (this.IsFactoryVisit) {
          this.IsFactoryVisit = "Yes";
        } else {
          this.IsFactoryVisit = "No";
        }

        this.registerForm.patchValue({
          Address1: this.formdata.Address1,
          Address2: this.formdata.Address2,
          Comments: this.formdata.Comments,
          ContactId: this.formdata.ContactId,
          ContactName: this.formdata.ContactName,
          DateOfBirth: this.formdata.DateOfBirth,
          Email: this.formdata.Email,
          EmailId: this.formdata.EmailId,
          FactoryVisitComments: this.formdata.FactoryVisitComments,
          Gender: this.formdata.Gender,
          IsFactoryVisit: this.formdata.IsFactoryVisit,
          IsVVIP: this.formdata.IsVVIP,
          Landline: this.formdata.Landline,
          Mobile: this.formdata.Mobile,
          WhatsappNumber: this.formdata.WhatsappNumber,
          Nationality: this.formdata.NationalityName,
          Designation: this.formdata.DesignationName,
          Country: this.formdata.CountryName,
          State: this.formdata.StateName,
          City: this.formdata.CityName,
          ContactOwner: this.formdata.UserName,
          Language: this.formdata.LanguageName,
          Company: this.formdata.CompanyName,
          Religion: this.formdata.ReligionName,
          ProReservation: this.formdata.ProReservationName,
        })
      }
    })

  }

}
